import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  useMemo,
} from "react";
import {
  ApolloProvider,
  ApolloClient,
  InMemoryCache /*, split, HttpLink */,
} from "@apollo/client";
import axios from "axios";
import { Button } from "reactstrap";
import {
  QueryClientProvider,
  QueryClient,
  useQuery as useRestQuery,
} from "react-query";
// import { ReactQueryDevtools } from 'react-query/devtools'
import useLocalStorage from "react-use-localstorage";
import { FormattedMessage, useIntl } from "react-intl";
// import { getMainDefinition } from '@apollo/client/utilities';
import { WebSocketLink } from "@apollo/client/link/ws";

import UserContext, { User } from "./contexts/user";

import { PreLoader } from "./components/preloader";

import { ScheduleBasicEndpointResponseObject } from "./types/presentation";

import App from "./App";
import io from "socket.io-client";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
    mutations: {
      // mutation options
    },
  },
});

const AppContext = ({ socket }: { socket: any }) => {
  const [user, setUser] = useState<null | User>(null);
  const [showLogin, setShowLogin] = useState(false);
  const [currentEvent, setCurrentEvent] = useState<any>(null);
  // const slug = document.location.pathname.split("/")[1] || "invalid";
  const slug = document.location.pathname.split("/")[1] || "invalid";
  const [oneTimeShowLogin, setOneTimeShowLogin] = useState(false);
  const [redirectPath, setRedirectPath] = useState("");
  const [listUser, setListUser] = useLocalStorage(
    `list-user-${slug}`,
    JSON.stringify({ token: "", id: "" })
  );
  const [authHeader, setAuthHeader] = useState<string>("");


  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        showLogin,
        setShowLogin,
        oneTimeShowLogin,
        setOneTimeShowLogin,
        redirectPath,
        setRedirectPath,
        currentEvent,
        setCurrentEvent,
        listUser,
        setListUser,
        authHeader,
        setAuthHeader,
      }}
    >

      <QueryClientProvider client={queryClient}>
        <WithHasuraContext socket={socket} />
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </UserContext.Provider>
  );
};

export default AppContext;

const WithHasuraContext = ({ socket }: { socket: any }) => {
  const intl = useIntl();
  const userContext = useContext(UserContext);
  const [client, setClient] = useState<any>(false);
  const slug = useMemo(() => document.location.pathname.split("/")[1], []);
  const [eventPassword, setEventPassword] = useLocalStorage(
    `event-password-${slug}`,
    ""
  );

  const [passwordField, setPasswordField] = useState<string>("");

  const {
    listUser,
    setAuthHeader,
    currentEvent,
    setCurrentEvent,
    user,
    setUser,
    setShowLogin,
  } = userContext;

  const configureApolloClient = useCallback(
    (e) => {
      const getAuthToken = async () => {
        try {
          let authHeader = "";
          authHeader = JSON.parse(listUser).token
            ? `Bearer ${JSON.parse(listUser).token}`
            : "";
          //  console.log('debug: ', e, e._id);
          setAuthHeader(authHeader);
          //  console.log('debug: ', { authHeader })

          // const httpLink = new HttpLink({
          //   uri: `https://${process.env.REACT_APP_ENGAGEMENT_ENDPOINT}`,
          //   headers: authHeader ? {
          //     Authorization: authHeader
          //   } : {},
          // });

          const wsLink = new WebSocketLink({
            uri: `ws${process.env.REACT_APP_ENV === "dev" ? "" : "s"}://${process.env.REACT_APP_ENGAGEMENT_ENDPOINT
              }`,
            options: {
              reconnect: true,
              lazy: true,
              connectionParams: () => ({
                headers: authHeader
                  ? {
                    Authorization: authHeader,
                  }
                  : {},
              }),
            },
          });

          // const splitLink = split(
          //   ({ query }) => {
          //     const definition = getMainDefinition(query);
          //     return (
          //       definition.kind === 'OperationDefinition' &&
          //       definition.operation === 'subscription'
          //     );
          //   },
          //   wsLink,
          //   httpLink,
          // );

          const c = new ApolloClient({
            // link: splitLink,
            link: wsLink,
            cache: new InMemoryCache({
              // typePolicies: {
              //   question: {
              //     merge: true,
              //   }
              // }
            }),
          });
          setClient(c);
        } catch (e) {
          // no user
          // console.error(e);
          setClient(
            new ApolloClient({
              uri: `http${process.env.REACT_APP_ENV === "dev" ? "" : "s"}://${process.env.REACT_APP_ENGAGEMENT_ENDPOINT
                }`,

              cache: new InMemoryCache(),
            })
          );
        }
      };
      getAuthToken();
    },
    [listUser, setAuthHeader]
  );

  useEffect(() => {
    //  console.log('debug: currentEvent: ', currentEvent);
    if (!currentEvent) {
      return;
    }
    configureApolloClient(currentEvent);
  }, [configureApolloClient, currentEvent]);
  console.log("slug inside context ", slug)
  const { data, isLoading, isError, refetch } = useRestQuery(
    "event-basic",
    async () => {
      console.log("url in context page ", `${process.env.REACT_APP_API_ENDPOINT}/api/public/schedule-basic/${slug}`)
      const response = await axios.get<ScheduleBasicEndpointResponseObject>(
        `${process.env.REACT_APP_API_ENDPOINT}/api/public/schedule-basic/${slug}`,
        {
          params: { password: eventPassword },
        }
      );
      return response.data;
    },
    {
      enabled: !!slug,
    }
  );

  useEffect(() => {
    if (eventPassword) {
      refetch();
    }
  }, [eventPassword, refetch]);

  useEffect(() => {
    if (!data) {
      return;
    }

    // @ts-ignore
    const { event } = data?.data;
    //  console.log('debug: ', { event });
    setCurrentEvent(event);

    const setupAuth = async () => {
      if (!user && !event.allowAnonymousAccess) {
        setShowLogin(true);
      } else {
        setShowLogin(false);
      }

    };
    setupAuth();
  }, [data, user, setShowLogin, setUser, setCurrentEvent]);

  if (!slug) {
    // TODO
    return (
      <div className="login-landing">
        <div className="login-container">
          <div className="login">
            <h4>Invalid link</h4>
          </div>
        </div>
      </div>
    );
  }

  // if (isLoading) return <i>App.tsx: isLoading</i>
  if (isLoading) return <PreLoader />;

  if (isError || !data)
    return (
      <div>
        {/* <div className="login-landing">
        <div className="login-container">
          <div className="login">
            <h4>
              <FormattedMessage id="error.retry.message" />
            </h4>
          </div>
        </div>
      </div> */}
      </div>
    );

  if (
    data?.message === "error.prompt-password" ||
    data?.message === "error.invalid-password"
  ) {
    return (
      <div className="login-landing">
        <div className="login-container">
          <div className="login">
            {data?.message === "error.invalid-password" && (
              <b>
                <FormattedMessage id="invalid.password" />
                <br />
                <br />
              </b>
            )}
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setEventPassword(passwordField);
              }}
            >
              <input
                type="password"
                placeholder={intl.formatMessage({ id: "common.password" })}
                className="form-control m-b-10"
                name="password"
                onChange={(e) => setPasswordField(e.target.value)}
              />
              <Button block color="primary" type="submit">
                <FormattedMessage id="common.enter.button" />
              </Button>
            </form>
          </div>
        </div>
      </div>
    );
  }



  if (!client) return <PreLoader />;

  return (
    <ApolloProvider client={client}>
      <App socket={socket} />
    </ApolloProvider>
  );
};
